import { Component } from "@angular/core";
import { Router, ChildActivationEnd, ActivatedRoute, PRIMARY_OUTLET, NavigationEnd, NavigationStart } from "@angular/router";
import { filter } from "rxjs/operators";
import { BreadcrumbService } from "../../../services/breadcrumb.service";
import { ProfileService } from "../../../services/profile.service";

export interface BreadcrumbInterface {
	label: string;
	url?: string
}

@Component({
	selector: "app-bread-crumb",
	templateUrl: "./bread-crumb.component.html",
	styleUrls: ["./bread-crumb.component.scss"]
})
export class BreadCrumbComponent {

	currentRoute: string;
	homeBreadcrumb = { label: 'home', url: '' };
	breadcrumbs: BreadcrumbInterface[] = [];
	detailsId: string;
	breadcrumbInterval;
	intervalTime: number = 0;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private breadcrumbService: BreadcrumbService,
		private profileService: ProfileService
	) {
		this.homeBreadcrumb.url = `/${this.profileService.profileType}/overview`;

		this.breadcrumbService.breadcrumbId$.subscribe(id => {
			this.detailsId = id;
		});

		this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe(() => {
			this.detailsId = '';
		});

		this.router.events.pipe(filter(e => e instanceof ChildActivationEnd)).subscribe(() => {
			this.breadcrumbs = this.getBreadcrumbs(activatedRoute.root);
			this.breadcrumbs = [this.homeBreadcrumb, ...this.breadcrumbs];
			if(this.breadcrumbs.length > 2) {
				this.changeBreadcrumbId();
			}
		});

		this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((event) => {
			this.currentRoute = event['url'].substring(0, event['url'].includes('?') ? event['url'].lastIndexOf('?') : event['url'].length);
		});
	}

	changeBreadcrumbId() {
		const index = this.breadcrumbs.findIndex(breadcrumb => breadcrumb.url.includes('details'));
		if (index !== -1) {
			this.breadcrumbService.breadcrumbId$.subscribe(id => {
				this.detailsId = id;
				this.breadcrumbs[index].label = this.detailsId;
			});
		}
	}

	getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: BreadcrumbInterface[] = []): BreadcrumbInterface[] {
		const children: ActivatedRoute[] = route.children;

		if (children.length === 0) {
			return breadcrumbs;
		}

		for (const child of children) {
			if (child.outlet === PRIMARY_OUTLET) {
				const breadcrumbLabel = child.snapshot.data['breadcrumb'];
				const routeUrl: string = child.snapshot.url
					.map(segment => segment.path)
					.filter(path => path)
					.join('/');
				const nextUrl = routeUrl ? `${url}/${routeUrl}` : url;

				if (routeUrl && breadcrumbLabel) {
					const breadcrumb: BreadcrumbInterface = {
						label: nextUrl.includes('details') ? this.detailsId : breadcrumbLabel,
						url: nextUrl
					};
					breadcrumbs.push(breadcrumb);
				}

				return this.getBreadcrumbs(child, nextUrl, breadcrumbs);
			}
		}
		return breadcrumbs;
	}
}
